export default __webpack_public_path__ + "static/media/username_icon.5165fc36.svg";